import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Applicant from "./applicant.vue";
import LifeInsuranceModal from "./life-insurance-modal.vue";
import { getFullNameWithSalutationFrom } from "@Shared/utils/utils";
import { get } from "lodash";
import OtherProperties from "./other-properties.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MainApplicant",
  components: {
    Applicant,
    OtherProperties,
    LifeInsuranceModal
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    clientUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    agentUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    applicationId: {
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handlePageChange(page, opts) {
      this.$emit("page-change", page, opts);
    },
    handleReplicate() {
      this.$emit("save");
    },
    handleSave() {
      this.$emit("save");
    },
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    handleChangeHeight(path, opts = {}) {
      var _this$$children$, _this$$children$$$chi, _this$$children$2, _this$$children$2$$ch, _mainAppOtherProperti, _mainAppOtherProperti2, _coappOtherProperties, _coappOtherProperties2;
      if (this.editVisibility) return;
      const mainAppRef = this.$children[0].$refs[path];
      const coappRef = this.$children[1].$refs[path];
      const mainAppOtherPropertiesRef = (_this$$children$ = this.$children[0]) == null ? void 0 : (_this$$children$$$chi = _this$$children$.$children) == null ? void 0 : _findInstanceProperty(_this$$children$$$chi).call(_this$$children$$$chi, child => child.$el.id === "other-properties-section-wrapper");
      const coappOtherPropertiesRef = (_this$$children$2 = this.$children[1]) == null ? void 0 : (_this$$children$2$$ch = _this$$children$2.$children) == null ? void 0 : _findInstanceProperty(_this$$children$2$$ch).call(_this$$children$2$$ch, child => child.$el.id === "other-properties-section-wrapper");
      const mainAppOtherPropertiesRefChildrenRef = ((_mainAppOtherProperti = mainAppOtherPropertiesRef.$children) == null ? void 0 : (_mainAppOtherProperti2 = _findInstanceProperty(_mainAppOtherProperti).call(_mainAppOtherProperti, child => child == null ? void 0 : child.$refs[path])) == null ? void 0 : _mainAppOtherProperti2.$refs[path]) || null;
      const coappOtherPropertiesRefChildrenRef = ((_coappOtherProperties = coappOtherPropertiesRef.$children) == null ? void 0 : (_coappOtherProperties2 = _findInstanceProperty(_coappOtherProperties).call(_coappOtherProperties, child => child == null ? void 0 : child.$refs[path])) == null ? void 0 : _coappOtherProperties2.$refs[path]) || null;
      if (!mainAppRef && !coappRef && !mainAppOtherPropertiesRefChildrenRef && !coappOtherPropertiesRefChildrenRef) return;
      const mainAppChildRef = opts.otherProperties && mainAppOtherPropertiesRefChildrenRef ? mainAppOtherPropertiesRefChildrenRef == null ? void 0 : mainAppOtherPropertiesRefChildrenRef.querySelector(".resize-wrapper").offsetHeight : mainAppRef && mainAppRef.querySelector(".resize-wrapper").offsetHeight;
      const coappRefChildRef = opts.otherProperties && coappOtherPropertiesRefChildrenRef ? coappOtherPropertiesRefChildrenRef == null ? void 0 : coappOtherPropertiesRefChildrenRef.querySelector(".resize-wrapper").offsetHeight : coappRef && coappRef.querySelector(".resize-wrapper").offsetHeight;
      const maxHeight = Math.max(mainAppChildRef, coappRefChildRef);
      $(opts.otherProperties ? mainAppOtherPropertiesRefChildrenRef : mainAppRef).css({
        "min-height": `calc(${maxHeight}px + .5rem`
      });
      $(opts.otherProperties ? coappOtherPropertiesRefChildrenRef : coappRef).css({
        "min-height": `calc(${maxHeight}px + .5rem`
      });
    },
    handleHeightRemove(path, opts = {}) {
      var _this$$children$3, _context, _this$$children$4, _context2, _mainAppOtherProperti3, _mainAppOtherProperti4, _coappOtherProperties3, _coappOtherProperties4;
      if (this.editVisibility) return;
      const mainAppRef = this.$children[0].$refs[path];
      const coappRef = this.$children[1].$refs[path];
      const mainAppOtherPropertiesRef = (_this$$children$3 = this.$children[0]) == null ? void 0 : _findInstanceProperty(_context = _this$$children$3.$children).call(_context, child => child.$el.id === "other-properties-section-wrapper");
      const coappOtherPropertiesRef = (_this$$children$4 = this.$children[1]) == null ? void 0 : _findInstanceProperty(_context2 = _this$$children$4.$children).call(_context2, child => child.$el.id === "other-properties-section-wrapper");
      const mainAppOtherPropertiesRefChildrenRef = ((_mainAppOtherProperti3 = mainAppOtherPropertiesRef.$children) == null ? void 0 : (_mainAppOtherProperti4 = _findInstanceProperty(_mainAppOtherProperti3).call(_mainAppOtherProperti3, child => child == null ? void 0 : child.$refs[path])) == null ? void 0 : _mainAppOtherProperti4.$refs[path]) || null;
      const coappOtherPropertiesRefChildrenRef = ((_coappOtherProperties3 = coappOtherPropertiesRef.$children) == null ? void 0 : (_coappOtherProperties4 = _findInstanceProperty(_coappOtherProperties3).call(_coappOtherProperties3, child => child == null ? void 0 : child.$refs[path])) == null ? void 0 : _coappOtherProperties4.$refs[path]) || null;
      if (!mainAppRef && !coappRef && !mainAppOtherPropertiesRefChildrenRef && !coappOtherPropertiesRefChildrenRef) return;
      $(opts.otherProperties ? mainAppOtherPropertiesRefChildrenRef : mainAppRef).css({
        "min-height": ""
      });
      $(opts.otherProperties ? coappOtherPropertiesRefChildrenRef : coappRef).css({
        "min-height": ""
      });
    },
    getFullName(type) {
      const {
        "personal-details": personalDetails
      } = get(this.currentApplication, type);
      return getFullNameWithSalutationFrom(personalDetails);
    },
    handleOpenLifeInsuranceModal() {
      this.$emit("open-life-insurance-modal");
    }
  }
});